"use strict";
/**
 * Job Category Constants
 *
 * Enum and groupings for classifying jobs by function.
 * Used by shift validations and business rules instead of comparing job titles.
 *
 * @example
 * // Check if a job is veterinary staff
 * VET_CATEGORIES.includes(job.category)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_MEDICAL_CATEGORIES = exports.VET_CATEGORIES = exports.JOB_CATEGORY_LABELS = exports.JobCategory = void 0;
/**
 * Functional category for a job position.
 *
 * Decouples business logic from job titles so titles can be renamed
 * without breaking shift validations or other rules.
 */
var JobCategory;
(function (JobCategory) {
    JobCategory["MEDICAL_DIRECTOR"] = "MEDICAL_DIRECTOR";
    JobCategory["VET"] = "VET";
    JobCategory["VET_ASSISTANT"] = "VET_ASSISTANT";
    JobCategory["TRAINEE"] = "TRAINEE";
    JobCategory["RECEPTIONIST"] = "RECEPTIONIST";
    JobCategory["ADMIN"] = "ADMIN";
    JobCategory["ADVISOR"] = "ADVISOR";
})(JobCategory || (exports.JobCategory = JobCategory = {}));
exports.JOB_CATEGORY_LABELS = {
    [JobCategory.MEDICAL_DIRECTOR]: "Director médico",
    [JobCategory.VET]: "Veterinario",
    [JobCategory.VET_ASSISTANT]: "Asistente veterinario",
    [JobCategory.TRAINEE]: "Practicante",
    [JobCategory.RECEPTIONIST]: "Recepcionista",
    [JobCategory.ADMIN]: "Administrativo",
    [JobCategory.ADVISOR]: "Asesor",
};
/**
 * Jobs that count as veterinarians for shift coverage rules.
 * Includes directors and full vets.
 */
exports.VET_CATEGORIES = [
    JobCategory.MEDICAL_DIRECTOR,
    JobCategory.VET,
];
/**
 * All medical/clinical staff — vets + assistants + trainees.
 * Used for total clinical headcount validations.
 */
exports.ALL_MEDICAL_CATEGORIES = [
    ...exports.VET_CATEGORIES,
    JobCategory.VET_ASSISTANT,
    JobCategory.TRAINEE,
];
